import {
  Directive,
  ElementRef,
  HostListener,
  inject,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[etAtomsDocumentScrollOnMouseMove]',
  standalone: true,
})
export class DocumentScrollOnMouseMoveDirective {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  private lastMouseY!: number | undefined;
  /** Adjust this value to control scroll speed  */
  private scrollSensitivity = 7;

  /**
   * Handles the mouse move event to scroll the element vertically.
   *
   * This method calculates the vertical scroll position of the element based on the mouse movement.
   * It ensures that scrolling only occurs if the element is scrollable and keeps the scroll position
   * within the bounds of the element's scrollable area.
   *
   * @param {MouseEvent} event - The mouse move event triggered by the user.
   */
  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent): void {
    const element = this.el.nativeElement;

    // Only scroll if the element is actually scrollable
    if (element.offsetHeight < element.scrollHeight) {
      if (this.lastMouseY !== undefined) {
        const deltaY = event.clientY - this.lastMouseY;
        const newScrollTop =
          element.scrollTop + deltaY * this.scrollSensitivity; // Changed '-' to '+' to change scroll direction

        // Keep scroll position within bounds
        if (
          newScrollTop >= 0 &&
          newScrollTop <= element.scrollHeight - element.offsetHeight
        ) {
          this.renderer.setProperty(element, 'scrollTop', newScrollTop);
        }
      }
      this.lastMouseY = event.clientY;
    } else {
      // Reset lastMouseY if not scrollable to avoid initial jump if it becomes scrollable later
      this.lastMouseY = undefined;
    }
  }
}
